// Collection Banner YouTube Video Player Handler
// Handles autoplay with unmute for better mobile UX

class CollectionVideoPlayer {
  constructor() {
    this.players = new Map();
    this.init();
  }

  init() {
    // Wait for deferred media to load YouTube iframes
    document.addEventListener('click', (e) => {
      const poster = e.target.closest('.collection-hero__video-poster');
      if (!poster) return;

      const deferredMedia = poster.closest('deferred-media');
      if (!deferredMedia) return;

      // Wait for iframe to be inserted from template
      setTimeout(() => {
        const iframe = deferredMedia.querySelector('iframe.js-youtube');
        if (iframe) {
          this.enhanceYouTubePlayer(iframe);
        }
      }, 100);
    });
  }

  enhanceYouTubePlayer(iframe) {
    // YouTube iframe API will autoplay muted
    // Add unmute button overlay for mobile users
    const container = iframe.closest('.collection-hero__video-player');
    if (!container || container.querySelector('.video-unmute-btn')) return;

    // Create unmute button
    const unmuteBtn = document.createElement('button');
    unmuteBtn.className = 'video-unmute-btn';
    unmuteBtn.setAttribute('aria-label', 'Unmute video');
    unmuteBtn.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 5L6 9H2v6h4l5 4V5zM15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="23" y1="1" x2="1" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>Tap to unmute</span>
    `;

    // Add click handler to unmute
    unmuteBtn.addEventListener('click', () => {
      this.unmuteVideo(iframe, unmuteBtn);
    });

    container.appendChild(unmuteBtn);

    // Auto-hide button after 5 seconds
    setTimeout(() => {
      if (unmuteBtn.classList.contains('visible')) return;
      unmuteBtn.style.opacity = '0';
      setTimeout(() => unmuteBtn.remove(), 300);
    }, 5000);

    // Show button with fade in
    requestAnimationFrame(() => {
      unmuteBtn.classList.add('visible');
    });
  }

  unmuteVideo(iframe, button) {
    // Send message to YouTube iframe to unmute
    try {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"unMute","args":""}',
        '*'
      );

      // Update button to show muted state
      button.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 5L6 9H2v6h4l5 4V5zM15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Unmuted</span>
      `;

      button.classList.add('unmuted');

      // Fade out button after 2 seconds
      setTimeout(() => {
        button.style.opacity = '0';
        setTimeout(() => button.remove(), 300);
      }, 2000);
    } catch (error) {
      console.log('Could not unmute video:', error);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionVideoPlayer();
  });
} else {
  new CollectionVideoPlayer();
}
